// @ts-nocheck
import React from 'react';

/**
 * Dashboard page content.
 */
export function DashboardPageContent({ children }) {
  return <div class="dashboard__page-content">{children}</div>;
}
